import { Order } from '@Types/cart';

export class OrderUtils {
  public static readonly ORDER_STATES = ['open', 'confirmed', 'complete', 'cancelled'];
  public static readonly SHIPMENT_STATES = ['shipped'];

  public static getOrderState(order: Order): string | undefined {
    const orderState = order.orderState?.toLowerCase();
    if (orderState === 'confirmed') {
      const shipmentState = order.shipmentState?.toLowerCase();
      if (shipmentState && OrderUtils.SHIPMENT_STATES.includes(shipmentState)) {
        return shipmentState;
      }
    }
    return orderState && OrderUtils.ORDER_STATES.includes(orderState) ? orderState : undefined;
  }
}
